module.exports = __webpack_public_path__ + "img/icon_dabiaoti.c74d0ab4.png";